import {fetchApiBlob} from 'shared/actions/fetchApi'
import {actionMap} from '../reducers/index'
import * as types from './types'
import {createBlob} from 'shared/utils/createBlob'
import resetError from "shared/errorHandler/actions/resetError"
import handleError from "shared/errorHandler/actions/handleError"
import {downloadBlob} from 'shared/utils/downloadBlob'

export default (flightId) => async dispatch => {
    dispatch({type: types.GET_EFF_START})
    dispatch(resetError())
    try {
        const response = await fetchApiBlob('/api/fb/briefing/' + flightId + '/eff');
        if (response.status !== 200) {
            const error = new Error(response.statusText)
            error.response = response
            throw error
        }
        const blob = createBlob(await response.text(), 'application/octet-stream')
        const headerContent = response.headers.get("content-disposition")
        const fileName = headerContent ? headerContent.split("filename=")[1] : 'file.eff'
        downloadBlob(blob, fileName)
        dispatch({type: types.GET_EFF_SUCCESS})
    } catch (error) {
        dispatch({type: types.GET_EFF_FAILURE})
        dispatch(handleError({message: error.message, title: 'Error loading Electronic Flight Folder.'}))
    }
}

export const handler_GET_EFF_START = (reduxState) => {
    if (reduxState.blobUrl !== undefined)
        URL.revokeObjectURL(reduxState.blobUrl)

    return ({
        ...reduxState,
        loadingToolbarButtons: {...reduxState.loadingToolbarButtons, effBtn: true},
    })
}

export const handler_GET_EFF_SUCCESS = (reduxState) => {
    return ({
        ...reduxState,
        loadingToolbarButtons: {...reduxState.loadingToolbarButtons, effBtn: false},
    })
}

export const handler_GET_EFF_FAILURE = (reduxState) => {
    return ({
        ...reduxState,
        loadingToolbarButtons: {...reduxState.loadingToolbarButtons, effBtn: false}
    })
}

actionMap[types.GET_EFF_START] = handler_GET_EFF_START
actionMap[types.GET_EFF_SUCCESS] = handler_GET_EFF_SUCCESS
actionMap[types.GET_EFF_FAILURE] = handler_GET_EFF_FAILURE


// WEBPACK FOOTER //
// ./src/screens/briefing/products/actions/getEFF.js